<template>
  <div class="cover">
    <div class="close" aria-label="Close" @click="close">
      <span aria-hidden="true">&times;</span>
    </div>

    <div class="cropButton" title="обрезать" @click="crop()">
      <span>Обрезать в выделение</span>&nbsp;
      <svg class="bi bi-crop" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1H3.5a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 .5-.5z"/>
        <path fill-rule="evenodd" d="M.5 3.5A.5.5 0 0 1 1 3h2.5a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5zm5.5 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5zM14.5 14a.5.5 0 0 1 .5.5V17a.5.5 0 0 1-1 0v-2.5a.5.5 0 0 1 .5-.5z"/>
      </svg>
    </div>

    <div class="rotateButtons">
        <button class="btn btn-default rotateLeft rotateButton" @click="rotate(-90)">
            <svg aria-hidden="true" height="1em" width="1em" focusable="false" data-prefix="fas" data-icon="undo" class="svg-inline--fa fa-undo fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"></path></svg>
            Повернуть
        </button>
        <button class="btn btn-default rotateRight rotateButton" @click="rotate(90)">
            Повернуть
            <svg aria-hidden="true" height="1em" width="1em" focusable="false" data-prefix="fas" data-icon="undo" class="svg-inline--fa fa-undo fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path
     d="m 291.99958,224.333 h 200.333 c 6.627,0 12,-5.373 12,-12 V 12 c 0,-6.627 -5.373,-12 -12,-12 h -48 c -6.627,0 -12,5.373 -12,12 V 90.112 C 386.55958,39.279 320.07258,7.47 246.15758,8.007 109.25158,9.001 -0.29042156,119.63 5.7844021e-4,256.539 0.29157844,393.258 111.21258,504 247.99958,504 c 64.089,0 122.496,-24.313 166.51,-64.215 5.099,-4.622 5.334,-12.554 0.467,-17.42 l -33.967,-33.967 c -4.474,-4.474 -11.662,-4.717 -16.401,-0.525 -31.036,27.463 -71.856,44.127 -116.609,44.127 -97.268,0 -176.000002,-78.716 -176.000002,-176 0,-97.267 78.716002,-176 176.000002,-176 58.496,0 110.28,28.476 142.274,72.333 h -98.274 c -6.627,0 -12,5.373 -12,12 v 48 c 0,6.627 5.373,12 12,12 z" style="fill:currentColor" /></svg>
        </button>
    </div>

    <button class="btn btn-warning cancelButton" @click="close">Отмена</button>
    <button class="btn btn-primary btn-lg saveButton" v-if="isPhotoChanged" @click="save">Сохранить</button>

    <tui-image-editor :include-ui="false" ref="tui_editor"></tui-image-editor>
  </div>
</template>

<script>

import ImageEditor from '@toast-ui/vue-image-editor/src/ImageEditor.vue'

export default {
  data() {
    return {
      oldFoto: this.$store.getters.getOldFoto,
      mode: null,
      isPhotoChanged: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const img = new Image()

      img.onload = () => {
          //const w = img.width, h = img.height;
          const editor = this.getEditor();

        editor.invoke('loadImageFromURL', img.src, 'Фото').then(() => this.startCropMode());
      }

      img.src = this.oldFoto
    },
    crop() {
      const editor = this.getEditor();
      const cropRect = editor.invoke('getCropzoneRect');
      if (cropRect) {
        editor.invoke('crop', cropRect);
        this.isPhotoChanged = true;
      }
    },
    startCropMode() {
      const editor = this.getEditor();

      editor.invoke('startDrawingMode', 'CROPPER') && editor.invoke('setCropzoneRect', 3/4);
      this.mode = 'cropping';
    },
    rotate(degrees) {
        const editor = this.getEditor();

        editor.invoke('rotate', degrees, false).then(() => {
            editor.invoke('stopDrawingMode')
            this.startCropMode();
        });

    },
    save() {
      this.$emit('get-foto', this.getEditor().invoke('toDataURL', {format: 'png'}));
      this.close();
    },
    getEditor() {
      return this.$refs.tui_editor;
    },
    close() {
      this.$store.commit('setShowFotoRedactor', false)
    }
  },
  components: {
      'tui-image-editor': ImageEditor
  }
}
</script>

<style scoped>
  .cover {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 10;
    width: 90%;
    height: 90%;
    background-color: grey;
    overflow: hidden;
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 100;
    cursor: pointer;
  }
  .cropButton {
    position: absolute;
    top: 40px;
    right: 10px;
    z-index: 100;
    cursor: pointer;
    color: yellow;
    font-size: 22px;
    border: 1px solid yellow;
    border-radius: 5px;
    width: auto;
    /** height: 40px; **/
    text-align: center;
    background-color: gray;
    padding: 10px;
  }

  .saveButton {
    position: absolute;
    top: 120px;
    right: 10px;
  }

  .cancelButton {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .rotateButtons {
      position: absolute;
      bottom: 70px;
      right: 10px;
  }

  .rotateLeft {
      margin-right: 10px;
  }

</style>
<style>
  .tui-image-editor-canvas-container {
      margin: 10px auto;
  }
</style>
